import { render, staticRenderFns } from "./policy_shssc.vue?vue&type=template&id=50743540&scoped=true"
import script from "./policy_shssc.vue?vue&type=script&lang=js"
export * from "./policy_shssc.vue?vue&type=script&lang=js"
import style0 from "./policy_shssc.vue?vue&type=style&index=0&id=50743540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50743540",
  null
  
)

export default component.exports